import { render, staticRenderFns } from "./AdminExtraComponent.vue?vue&type=template&id=57a86e8e&"
import script from "./AdminExtraComponent.vue?vue&type=script&lang=js&"
export * from "./AdminExtraComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports